import dialogFactory from '@kso/ui/lib/Dialog'
import Appeal from './src/appealDialog.vue'
import './dialog.scss'

(Appeal as any).name = Appeal.name || 'appealDialog'

const dialog = dialogFactory({
  entry: Appeal,
  pages: [
    {
      className: 'pc-appeal-dialog',
      width: '450px',
      height: '360px',
      body: Appeal,
      footer: null,
      closeOnClickModal: false,
      // title: '申诉恢复访问',
      hideHeader: true
    }
  ]
})

export default dialog
